
<ci-button 
  class="details-header__button"
  [class.is-speaker-entry]="isSpeakerEntry()"
  [class.is-action-button]="isActionButton()"
  class-name="ci-btn-primary-m-outlined" 
  type="button" 
  [attr.aria-label]=" text() | translate "
>
  <span class="ci-paragraph-p3-semibold button__label">
    {{ text() | translate }}
  </span>
</ci-button>